import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BottomSection, Gallery, MainColumn, TopBar } from "@/components";
import { Breadcrumb } from "@/components/Breadcrumb";
import { ContactCardColumn, StickyCta } from "@/components/contacting";
import { FeedbackSurvey } from "@/components/FeedbackSurvey";
import { SimilarListings } from "@/components/SimilarListings";
import { SectionsBIC } from "./components/Sections/SectionsBIC";
export const TemplateBIC = () => {
    return (_jsxs(_Fragment, { children: [_jsx(TopBar, {}), _jsxs(MainColumn, { children: [_jsx(Gallery, {}), _jsx(SectionsBIC, {})] }), _jsx(ContactCardColumn, {}), _jsx(FeedbackSurvey, {}), _jsx(SimilarListings, {}), _jsx(Breadcrumb, {}), _jsx(BottomSection, {}), _jsx(StickyCta, { tracking: { avZone: "sticky" } })] }));
};
